import { render, staticRenderFns } from "./SpellcheckerPanel.vue?vue&type=template&id=91112f1e&scoped=true"
import script from "./SpellcheckerPanel.vue?vue&type=script&lang=js"
export * from "./SpellcheckerPanel.vue?vue&type=script&lang=js"
import style0 from "./SpellcheckerPanel.vue?vue&type=style&index=0&id=91112f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91112f1e",
  null
  
)

export default component.exports